import React from 'react';

export const CoinStackIcon = ({
  width = '40',
  height = '40',
  color = '#3966E0',
  'aria-hidden': ariaHidden = true,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={ariaHidden}
    {...rest}
  >
    <path
      d="M23.6259 7.03577C23.6277 4.98946 19.4551 3.33203 14.3139 3.33203C9.17261 3.33203 5.00373 4.99131 5 7.03577M5 7.03577C5 9.08209 9.16888 10.7395 14.3139 10.7395C19.4588 10.7395 23.6277 9.08209 23.6277 7.03577L23.6277 21.4062M5 7.03577V29.2581C5.00186 31.3044 9.17075 32.9618 14.3139 32.9618C16.8081 32.9618 19.0602 32.5674 20.7311 31.9322M5.00186 14.4432C5.00186 16.4895 9.17075 18.147 14.3157 18.147C19.4607 18.147 23.6296 16.4895 23.6296 14.4432M20.8429 24.4897C19.1627 25.1472 16.8584 25.5546 14.3139 25.5546C9.17075 25.5546 5.00186 23.8971 5.00186 21.8508M34.212 22.4398C37.4849 25.6935 37.4849 30.9713 34.212 34.2251C30.9391 37.4788 25.6302 37.4788 22.3573 34.2251C19.0844 30.9713 19.0844 25.6935 22.3573 22.4398C25.6302 19.186 30.9391 19.186 34.212 22.4398Z"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
